
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { mdiMagnify, mdiAccount } from '@mdi/js';
import { VuetifyMixin } from '@/mixins/VuetifyMixin';
import SharingMetric from "@/components/sharing/SharingMetric.vue";
import { SharingHistoryRecord } from '@/../types/interfaces';
import { formatDatePrettyLong } from '@/helpers/date';
import ShareProfile from "@/components/profile/recruiting/ShareProfile.vue";
import { DataTableHeader } from 'vuetify';
import { DataTableSortMixin } from '@/mixins';
import ProfilePictureProvider from '@/components/hoc/ProfilePictureProvider.vue';

@Component({
	components: {
		SharingMetric,
		ShareProfile,
		ProfilePictureProvider,
	}
})
export default class SharingHistory extends Mixins(DataTableSortMixin, VuetifyMixin){
	formatDatePrettyLong = formatDatePrettyLong;
	mdiMagnify = mdiMagnify;
	mdiAccount = mdiAccount;

	@Prop({ default: "" }) search: string;
	updateSearch(search: string): void{
		this.$emit('update:search', search);
	}

	headers: DataTableHeader<any>[] = [
		{
			text: '',
			value: '',
			sortable: false,
		},
		{
			text: 'Date',
			value: 'date',
			sortable: true,
		},
		{
			text: 'Email',
			value: 'email',
			sortable: true,
		},
	];

	showShareModal: boolean = false;
	/** Total number of records ie. Profile Shares */
	@Prop({ type: Number, required: true }) value: number;
	/** Label for total number; "Profile Shares", "Profile Views" */
	@Prop({ type: String, required: true }) label: string;
	@Prop({ default: [] }) records: SharingHistoryRecord[];

	submitShareProfile(payload: { emails: string[], message: string }): void{
		this.$emit('share', payload);
	}

}
